import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import SelectField from '../selectField/SelectField';
import { languagesListWithFlag } from '../../../utils/constants/languages';
import { getAvailableI18nLanguage } from '../../../utils/languageUtils';
import { LanguageCodeUnderscored } from '../../../i18n/internationalization.types';
import { LanguageSelectFieldProps } from './LanguageSelectField.types';

const LanguageSelectField: FC<LanguageSelectFieldProps> = ({
  name,
  options = languagesListWithFlag,
  normalizeValue,
  excludeLanguages = [],
  ...rest
}) => {
  const { watch, setValue } = useFormContext();

  const currentValue = watch(name);

  useEffect(() => {
    if (normalizeValue) {
      const normalizedValue = getAvailableI18nLanguage(currentValue);
      setValue(name, normalizedValue);
    }
  }, []);

  const filteredOptions = options.filter(
    (option) =>
      !excludeLanguages.includes(option.value as LanguageCodeUnderscored),
  );

  return <SelectField name={name} options={filteredOptions} {...rest} />;
};

export default LanguageSelectField;
